export default "__VITE_ASSET__CGqNeg24__"